module.exports = __webpack_public_path__ + "img/Pot1.svg";